import { BasicEntity } from "../../../core/models/basic-entity";
export class PriceList extends BasicEntity {
    //public ParentId?: PriceList;

    constructor(priceList?: Partial<PriceList>) {
        super();
        Object.assign(this, priceList);
    }
}